/** The six buyer firm types (CLAUDE.md, Buyer Firm Types). Anything else, or null, is unclassified. */
export const BUYER_FIRM_TYPES = [
  "Private Equity", "Strategic Acquirer", "Independent Sponsor", "Family Office", "Search Fund", "Other",
] as const;
/** firmType query value meaning "no known firm type". */
export const UNCLASSIFIED_FIRM_TYPE = "__unclassified";
